import fb from '@/services/firebase'

export const namespaced = true

export const state = {
  order_history: [],
  loading: false
}

export const mutations = {
  SET_ORDER_HISTORY(state, values) {
    state.order_history = values
  },
  SET_LOADING(state, value) {
    state.loading = value
  }
}

export const actions = {
  orderHistory({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ORDER_HISTORY', [])
    fb.auth.onAuthStateChanged(user => {
      if (user) {
        fb.db
          .collection('order_histories')
          .where('initiator_uid', '==', user.uid)
          .orderBy('placing_order.finished_at', 'desc')
          .onSnapshot(docs => {
            if (docs.empty == false) {
              var orders = []
              docs.forEach(doc => {
                var newDoc = doc.data()
                newDoc.doc_id = doc.id
                orders.push(newDoc)
              })
              commit('SET_ORDER_HISTORY', orders)
            } else {
              commit('SET_ORDER_HISTORY', [])
            }
          })
      }
    })
  }
}

export const getters = {}
